module.exports = __webpack_public_path__ + "static/img/multicampus_logo_mo@3x.9b8b7fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/multicampus_logo_mo@3x.png
// module id = UaQc
// module chunks = 10